import { stringArrayParam } from "@funds/utils/fund-compare-search-params";
import { createFileRoute, Outlet } from "@tanstack/react-router";
import { literal, object, string } from "zod";

export const Route = createFileRoute("/(auth)/(headless)/reports")({
  component: Outlet,
  validateSearch: object({
    sections: stringArrayParam.optional(),
    embed: literal(true).optional(),
    backtest_period: string().optional(),
    backtest_benchmark: string().optional(),
  }),
});
